import { defineStore } from 'pinia';
import ProfileEntity from '@/components/whatsapp-managment/entities/profile';
import { Alert } from '@/v2/plugins/alert';
import {t} from "@/locales/index";

export const useProfileStore = defineStore('chatProfileStore', {
	state: () => ({
		loading: false,
		loadingPage: false,
		form: {
			name: '',
			email: '',
			customer_address: {
				phone: '',
				building_number: '',
				street_name: '',
				city_id: '',
				city: '',
				district: '',
				address_type: '',
                receiver_name: ''
			},
		},
	}),
	actions: {
		async updateProfile(id) {
			const values = Object.assign({}, this.form);
			values['customer_address']['city_id'] = this.form.customer_address.city?.id;
			// delete values['customer_address']['city'];

			this.loading = true;
			try {
				if (id) {
					await ProfileEntity.update(id, values);
					Alert.success(t('updatedSuccessfully'));
				}
				return true;
			} catch (error) {
				Alert.error(error?.response?.data?.message);
			} finally {
				this.loading = false;
			}
		},

        async createProfile(externalId) {
            const values = Object.assign({}, this.form);
			values['customer_address']['city_id'] = this.form.customer_address.city?.id;
			values['external_id'] = externalId;
			values['name'] = this.form.name || this.form.customer_address?.receiver_name;
            values['phone_number'] = this.form.customer_address.phone;
            values['marketplace_id'] = 8;

			this.loading = true;
			try {
				const data = await ProfileEntity.create(values);
				Alert.success(t('createdSuccessfully'));
                return data;
			} catch (error) {
				Alert.error(error?.response?.data?.message);
                throw(error);
			} finally {
				this.loading = false;
			}
        },

		async getProfile(id) {
			this.loadingPage = true;
			try {
				try {
					const resp = await ProfileEntity.getProfile(id);
					const customer = resp?.data?.result?.customer;
                    const customer_address = customer?.customer_address;

					this.form = {
						name: customer?.name,
						email: customer?.email,
                        phone_number: customer?.phone_number,
						customer_address: {
							phone: customer_address?.phone ?? customer?.phone_number,
							building_number: customer_address?.building_number,
							street_name: customer_address?.street_name,
							city_id: customer_address?.city_id,
							city: customer_address?.city,
							district: customer_address?.district,
							address_type: customer_address?.address_type,
                            receiver_name: customer_address?.receiver_name,
						},
					};
				} catch (error) {
					console.error(error);
				} finally {
					this.loadingPage = false;
				}
			} catch (error) {
				console.error(error);
				this.loadingPage = false;
			}
		},
	},
});
